/**
 * sessionStorage flag set by a successful registration (email or phone) and
 * consumed once by `ApkDownloadAfterRegistration`, which then starts the APK download (AC-902).
 * Deliberately separate from `WELCOME_BONUS_JUST_REGISTERED_KEY`, which the login
 * form also sets.
 */
export const APK_PROMPT_AFTER_REGISTRATION_KEY = "apkPromptAfterRegistration";
